const INFO = {
	main: {
		title: "Xinwen Liu's Portfolio",
		name: "Xinwen Liu",
		email: "xl2796@columbia.edu",
		logo: "../logo.png",
	},

	socials: {
		github: "https://github.com/Xinwen-Liu-Wendy",
		linkedin: "https://www.linkedin.com/in/xinwen-liu-ml",
	},

	homepage: {
		title: "Xinwen Liu",
		description:
		"I am a Machine Learning Scientist focused on multimodal LLMs, agentic AI, model evaluation, and generative modeling. My work spans text, audio, and vision, with experience in building AI systems that can reason over long-form multimodal content, align with human judgment, and turn ambiguous research ideas into practical, impactful systems. I received my Ph.D. from Columbia University, where my research in computer vision, high-dimensional imaging, and AI for Science led to Nature Methods publications and patented algorithms.", },

	about: {
		title: "About Me",
		des1:"I am a ML Scientist working at the intersection of multimodal LLMs, agentic AI, model evaluation, and generative modeling. My current work at Amazon (Audible) focuses on building AI systems that can reason over long-form, multimodal content across text, audio, and vision, with interests in LLM/MLLM agents, human-aligned evaluation, feedback-driven optimization, and multimodal generation.",
		des2:"I received my Ph.D. from Columbia University, where my research combined computer vision, high-dimensional imaging, deep generative models, and AI for Science. This work led to publications in Nature Methods and patented algorithms.",
		des3:"I value thoughtful research, collaborative problem-solving, and persistence in difficult technical problems. I enjoy turning ambiguous ideas into rigorous methods, working AI systems, and real-world applications.",
		des4:"A few fun facts about me. I share my life with an adorable 7-year-old Japanese Spitz with the most charming fluffy white hair. He's my furry companion and always brings joy to my days. On top of that, I'm also a soprano, and my heart resonates with music. Together with a group of college friends, I co-founded an Acapella group called 'Luminors' and performing with them is an absolute delight.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
               {
                        title: "Supervised Learning and Anomaly Detection of Large-scale Imaging Data for Drug Discovery",
                        description:
                                "I developed a new profiling method for drug discovery with a complete data analysis pipeline. I introduced machine learning to analyze 100GB data, which achieved drug mechanism prediction with high accuracy (over 99%). I further designed a new algorthim using anomaly detection to discover novel drug candidates. The manuscript is now under review in a top academic journal Nature Methods.",
                        logo: "project1.png",
                        linkText: "View Details",
                        link: "/article/1",
                },

                {
                        title: "Unsupervised Learning and Multivariate Analysis of Large-scale Metabolic Imaging Data",
                        description:
                                "I implemented unsupervised learning and multivariate analysis to analyze 200GB metabolic imaging data. This analysis, for the first time, identified metabolism profile with important biological information. It further discovered metabolism difference inside brain tumor. This work was published in a top academic journal Advanced Science.",
                        logo: "project2.png",
                        linkText: "Paper Link",
                        link: "https://doi.org/10.1002/advs.202105437",
                },

                {
                        title: "Statistical Analysis of a New Metabolic Imaging technqiue",
                        description:
                                "I involved in the development of a new metabolic imaging technique with high imaging speed and high resolution. I further utilized statistical methods for data analysis, which successfully classified different cell subtypes and distinguished cells under drug treatments. This work was published in a top academic journal Nature Methods.",
                        logo: "project3.png",
                        linkText: "Paper Link",
                        link: "https://doi.org/10.1038/s41592-020-0883-z",
                },

                {
                        title: "Deep Learning for Multilingual Visual Question Answering (mVQA)",
                        description:
                                "Three transformer-based models were built for multilingual visual question answering (mVQA), which is a challenging multi-modal task requiring answering questions proposed from images in multiple languages. The models include vision transformer (ViT) + mT5, ViT + mBART, ViTMAE + mT5, where different vision and language models were selected to compare their individual effect on model performances. The best model achieved an average F1 score of 0.3427.",
                        logo: "project4.png",
                        linkText: "Github Link",
                        link: "https://github.com/Xinwen-Liu-Wendy/Multilingual-Visual-Question-Answering-mVQA",
                },


                {
                        title: "Deep Learning for Fluorescence Image Super-Resolution",
                        description:
                                "Three deep learning models were built for fluorescence image super-resolution (SR), including EDSR, SRGAN and SR3 (diffusion model). Systematic comparison of these three models were conducted with multiple evaluation metrics, which can provide valuable insights for biological image super-resolution.",
                        logo: "project5.png",
                        linkText: "Github Link",
                        link: "https://github.com/Xinwen-Liu-Wendy/DeepLearning-Fluorescence-Image-SuperResolution",
                },

                {
                        title: "Deep Learning for Instance Segmentation of Cell Nucleus",
                        description:
                                "A popular model in computer vision, MASK R-CNN, was implemented for instance segmentation of cell nuclei across multiple imaging modalities, including fluorescence imaging, wide-field imaging, H&E imaging, etc. As instance segmentation of cell nucleus is usually the first step in the image analysis workflow of multiple research areas, this project can greatly benefit these scientific research.",
                        logo: "project6.png",
                        linkText: "Github Link",
                        link: "https://github.com/Xinwen-Liu-Wendy/InstanceSegmenation-CellNuclei-MASK_R-CNN",
                },

                {
                        title: "Deep Learning for Infant Brain MRI 3D Segmentation",
                        description:
                                "I built a 3D DenseNet model for infant brain MRI 3D segmentation, which is a challenging task due to the lack of contrast between white matter and gray matter. The model was first trained with a larger adult brain MRI dataset and then with the small infant dataset using transfer learning, which achieved state-of-the-art segmentation accuracy of 0.908.",
                        logo: "project7.png",
                        linkText: "Github Link",
                        link: "https://github.com/Xinwen-Liu-Wendy/Deep-Learning-for-Infant-Brain-MRI-Tissue-Volumetric-Segmentation",
                },

                {
                        title: "Deep Learning for Electroencephalogram (EEG) Classification",
                        description:
                                "Three deep learning models were built for the classification of electroencephalogram (EEG) signals, which is the most common brain-computer interface. The models includes CNN, hybrid CNN-LSTM model and CNN-Transformer model. Systematic comparison was conducted for these three models, which can provide further insights into EEG classification.",
                        logo: "project8.png",
                        linkText: "Github Link",
                        link: "https://github.com/Xinwen-Liu-Wendy/DeepLearning-Brain-Interface-Classification",
                },
	],
};

export default INFO;
